import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-special-messages-counter',
    templateUrl: './special-messages-counter.component.html',
    styleUrls: ['./special-messages-counter.component.scss'],
    standalone: false
})
export class SpecialMessagesCounterComponent {
  @Input() messagesCounter: number
}
